import { useMemo } from 'react';
import cx from 'classnames';

import { HuzzleUserAvatar } from 'components/HuzzleUserAvatar';
import { PostSummary } from 'components/candidate/discussions';
import { Badge } from 'components/ComponentV2';
import { TBasicStudentSocietyWithPostsStat } from 'lib/models/discussion';
import { getBasicSocietyParticipant } from 'lib/utils/discussion';

import styles from './SocietyDiscussionCard.module.scss';

type SocietyDiscussionCardProps = {
  society: TBasicStudentSocietyWithPostsStat;
  onSelect: (society: TBasicStudentSocietyWithPostsStat) => void;
  isSelected?: boolean;
  className?: string;
};

const SocietyDiscussionCard: React.FC<SocietyDiscussionCardProps> = ({ className, society, onSelect, isSelected = false }) => {
  const { last_post: post, not_viewed_count, ...basicStudentSociety } = society;

  const societyInfo = useMemo(() => getBasicSocietyParticipant(basicStudentSociety), [basicStudentSociety]);

  return (
    <section className={cx(styles.container, className, { [styles.selected]: isSelected })} onClick={() => onSelect(society)}>
      <HuzzleUserAvatar user={societyInfo} size="large" />
      <div className={styles.info}>
        <p className={styles.name}>{societyInfo.name}</p>
        <PostSummary post={post} />
      </div>
      {not_viewed_count > 0 && <Badge>{not_viewed_count}</Badge>}
    </section>
  );
};

SocietyDiscussionCard.displayName = 'SocietyDiscussionCard';

export default SocietyDiscussionCard;
